var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 9.16659H6.41667C8.25 9.16659 9.16667 8.24992 9.16667 6.41659V4.58325C9.16667 2.74992 8.25 1.83325 6.41667 1.83325H4.58333C2.75 1.83325 1.83333 2.74992 1.83333 4.58325V6.41659C1.83333 8.24992 2.75 9.16659 4.58333 9.16659Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 9.16659H17.4167C19.25 9.16659 20.1667 8.24992 20.1667 6.41659V4.58325C20.1667 2.74992 19.25 1.83325 17.4167 1.83325H15.5833C13.75 1.83325 12.8333 2.74992 12.8333 4.58325V6.41659C12.8333 8.24992 13.75 9.16659 15.5833 9.16659Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 20.1666H17.4167C19.25 20.1666 20.1667 19.2499 20.1667 17.4166V15.5833C20.1667 13.7499 19.25 12.8333 17.4167 12.8333H15.5833C13.75 12.8333 12.8333 13.7499 12.8333 15.5833V17.4166C12.8333 19.2499 13.75 20.1666 15.5833 20.1666Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 20.1666H6.41667C8.25 20.1666 9.16667 19.2499 9.16667 17.4166V15.5833C9.16667 13.7499 8.25 12.8333 6.41667 12.8333H4.58333C2.75 12.8333 1.83333 13.7499 1.83333 15.5833V17.4166C1.83333 19.2499 2.75 20.1666 4.58333 20.1666Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.7da28e70bfd8583d6b3445be44634907.svg";
export { ForwardRef as ReactComponent };